module.exports = __webpack_public_path__ + "img/computer-boy.69c86094.png";